import { render } from "./bank_statement_verification.html?vue&type=template&id=2848ee0b&scoped=true&external"
import script from "./bank_statement_verification.js?vue&type=script&lang=js&external"
export * from "./bank_statement_verification.js?vue&type=script&lang=js&external"

import "./BankStatementVerificationReport.vue?vue&type=style&index=0&id=2848ee0b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2848ee0b"]])

export default __exports__